"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visitedTabsState = void 0;
var visitedTabsState = exports.visitedTabsState = function visitedTabsState(props, state) {
  var _props$tabs$props$sel;
  if (!props.keepMounted) return null;
  var name = (_props$tabs$props$sel = props.tabs[props.selectedIndex]) === null || _props$tabs$props$sel === void 0 ? void 0 : _props$tabs$props$sel.name;
  var visitedTabs = state.visitedTabs.filter(function (visited) {
    return props.tabs.some(function (tab) {
      return tab.name === visited;
    });
  });
  if (name && !visitedTabs.includes(name)) visitedTabs.push(name);
  return {
    visitedTabs: visitedTabs
  };
};